/**
 * Configuracion de captura de Contentsquare.
 *
 * Por defecto, Contentsquare enmascara inputs y textareas.
 * Esta configuracion permite desenmascarar elementos especificos
 * para que sean visibles en las grabaciones de sesion.
 *
 * CRITICO: Debe ejecutarse ANTES de injectContentsquareScript()
 *
 * @see https://docs.contentsquare.com/en/web/personal-data-handling/
 */

/**
 * Selectores CSS de elementos que deben ser visibles en las grabaciones.
 * Incluye todos los inputs de texto excepto contrasenas.
 */
const capturedSelectors = [
  'input[type="text"]',
  'input[type="email"]',
  'input[type="search"]',
  'input[type="tel"]',
  'input[type="url"]',
  "input:not([type])", // inputs sin tipo explicito (default: text)
  "textarea",
  "[data-cs-capture]",
].join(", ");

/**
 * Configura que elementos de Contentsquare se capturan sin enmascarar.
 * DEBE llamarse ANTES de injectContentsquareScript().
 */
export const configureContentsquareCapture = (): void => {
  window._uxa = window._uxa || [];
  window._uxa.push(["setCapturedElementsSelector", capturedSelectors]);
};
